<script setup lang="ts">
import { ref } from 'vue'
import IconComponent from '../ui/common/IconComponent.vue';
import ReportDrawer from './ReportDrawer.vue';

const isDrawerOpen = ref(false)

const toggleDrawer = () => {
  isDrawerOpen.value = !isDrawerOpen.value
}
</script>

<template>
  <div>
    <button
      @click="toggleDrawer"
      class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors relative"
      title="Reports"
    >
      <IconComponent name="ChartSpline" />
    </button>
    
    <ReportDrawer
      :is-open="isDrawerOpen"
      @close="isDrawerOpen = false"
    />
  </div>
</template>